export const DOCUMENT = 'document';
export const DIRECTORY = 'directory';
